module.exports = __webpack_public_path__ + "img/pcrown3.2757bb86.png";